import { Role } from "./role.model";

export class Account
{    
    id: number;
    name: string;
    surname: string;
    username: string;
    password: string;
    email: string;
    role: Role;
    creationDate: Date;
    company: string;
}


// WEBPACK FOOTER //
// ./src/app/+auth/common/model/account.model.ts